import r from "./ghl-ui.es1518.js";
import f from "./ghl-ui.es1466.js";
function o(t, e) {
  f(2, arguments);
  var a = r(t), u = r(e);
  return a.getTime() === u.getTime();
}
export {
  o as default
};
